import React from 'react';
import { useRouteMatch } from 'react-router';

import Translation from '@swf/components/Translation/Translation';
import { UserClubRole } from '@swf/core/types/Poker';
import { NoData, useCheckUserClubRole } from '@swf/poker';

import CreateTournamentButton from '../CreateTournamentButton/CreateTournamentButton';

import {
  TXTWCL_No_Results_to_Show,
  TXTWCL_You_will_see_a_leaderboard_aft_ELL
} from './NoResults.messages.json';
import styles from './NoResults.scss';

const NoResults: React.FC = () => {
  const {
    params: { clubId }
  } = useRouteMatch<{ clubId: string }>();
  const enableCreate = useCheckUserClubRole(clubId, [UserClubRole.Admin, UserClubRole.Manager]);

  return (
    <NoData
      className={styles.noData}
      primaryText={<Translation {...TXTWCL_No_Results_to_Show} />}
      secondaryText={<Translation {...TXTWCL_You_will_see_a_leaderboard_aft_ELL} />}
    >
      {enableCreate && <CreateTournamentButton />}
    </NoData>
  );
};

export default NoResults;
